import { AfterViewInit, Directive, ElementRef } from '@angular/core';

/**
 * Marks every input inside the host as "not a login field" for third party password
 * managers, so they stop offering to fill or save credentials over it.
 *
 * Intended for one-time security code inputs. The angular-code-input library already sets
 * the correct `autocomplete="one-time-code"` on the fields it renders, but the password
 * manager extensions do not act on that — they each read their own attribute — and the
 * library gives us no hook to add attributes to its inputs. Hence the directive.
 *
 * Usage: <code-input appIgnorePasswordManagers ...></code-input>
 */
@Directive({
    selector: '[appIgnorePasswordManagers]',
    standalone: true
})
export class IgnorePasswordManagersDirective implements AfterViewInit {
    /** 1Password, Bitwarden, LastPass and Dashlane respectively. */
    private static readonly IGNORE_ATTRIBUTES: ReadonlyArray<[string, string]> =
        [
            ['data-1p-ignore', ''],
            ['data-bwignore', ''],
            ['data-lpignore', 'true'],
            ['data-form-type', 'other']
        ];

    constructor(private readonly _host: ElementRef<HTMLElement>) {}

    ngAfterViewInit(): void {
        // The inputs are rendered by the child component, so they only exist once its view
        // has been created.
        this._host.nativeElement
            .querySelectorAll('input')
            .forEach((input) =>
                IgnorePasswordManagersDirective.IGNORE_ATTRIBUTES.forEach(
                    ([name, value]) => input.setAttribute(name, value)
                )
            );
    }
}
